import { render, staticRenderFns } from "./dialog-warning-navigation.vue?vue&type=template&id=bd23ae70&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-warning-navigation.vue"
export default component.exports